import React from "react";
import { URL_REGEX, normalizeUrl } from "../../helpers/aiOverviewHelpers.js";

const UrlToLinks = ({ text, keyPrefix = 'url' }) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  const parts = [];
  let lastIndex = 0;
  let keyCounter = 0;
  
  URL_REGEX.lastIndex = 0;
  
  let match;
  while ((match = URL_REGEX.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    const { cleanUrl, href, trailingPunctuation } = normalizeUrl(match[0]);
    
    parts.push(
      <a
        key={`${keyPrefix}-${keyCounter++}-${match.index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="ai-overview__url-link"
      >
        {cleanUrl}
      </a>
    );
    
    if (trailingPunctuation) {
      parts.push(trailingPunctuation);
    }
    
    lastIndex = match.index + match[0].length;
  }
  
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  return parts.length > 0 ? parts : text;
};

export default UrlToLinks;

